(() => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) document.documentElement.style.setProperty("scroll-behavior", "auto");

  const buy = document.querySelector("[data-mack-sticky-buy]");
  if (buy && window.matchMedia("(max-width: 799px)").matches) {
    const onScroll = () => buy.classList.toggle("is-stuck-mobile", window.scrollY > 280);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }
})();
